import req from './request'

const DEFAULT_ENDPOINTS = {
    noComplete: '/dumps/marketing/no-complete',
    Complete: '/dumps/marketing/complete',
    Statistic: '/dumps/marketing/statistic',
    calling: '/dumps/calling',
    driver: '/dumps/driver-info/general',
    promotion: '/dumps/driver-info/promotions',
    toWork: '/dumps/driver-info/to-work',
    comments: '/dumps/driver-info/comments',
    addcomment: '/dumps/driver-info/add-comment',
    assetCall: '/dumps/asset-call',
    detail: '/dumps/marketing/statistic/detail'
}

export default {
    noComplete(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.noComplete, param)
    },
    complete(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.Complete, param)
    },
    statistic(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.Statistic, param)
    },
    calling(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.calling, param)
    },
    driver(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.driver, param)
    },
    promotion(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.promotion, param)
    },
    toWork(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.toWork, param)
    },
    comments(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.comments, param)
    },
    addcomment(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.addcomment, param)        
    },
    assetCall(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.assetCall, param)
    },
    detail(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.detail, param)
    }
}